import { Button, IconButton, Tooltip } from '@mui/material';
import { List } from 'lucide-react';
import { FormattedMessage } from 'react-intl';
import { useSetRecoilState } from 'recoil';
import { datasourceModalOpenState } from '~/state/atoms/viewerAtoms';

export const AddFilesIconButton = () => {
    const setFileUploadModalOpen = useSetRecoilState(datasourceModalOpenState);
    return (
        <Tooltip
            title={<FormattedMessage id="showPatients" />}
            placement="bottom"
        >
            <IconButton
                color="primary"
                size="small"
                onClick={() => setFileUploadModalOpen(true)}
                sx={{
                    top: 0,
                    right: 0,
                }}
            >
                <List size={21} />
            </IconButton>
        </Tooltip>
    );
};

export const AddFilesButton = () => {
    const setFileUploadModalOpen = useSetRecoilState(datasourceModalOpenState);
    return (
        <Button
            data-testid="addFilesButton"
            onClick={() => setFileUploadModalOpen(true)}
            key="logoutPopup"
            variant="outlined"
            color="primary"
            size="small"
            fullWidth
        >
            <FormattedMessage id="addDataset" />
        </Button>
    );
};
